// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BookingsController from "./bookings_controller"
application.register("bookings", BookingsController)

import CardController from "./card_controller"
application.register("card", CardController)

import CharCounterController from "./char_counter_controller"
application.register("char-counter", CharCounterController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CarsController from "./cars_controller"
application.register("cars", CarsController)

import DocxtemplaterController from "./docxtemplater_controller"
application.register("docxtemplater", DocxtemplaterController)

import DrawerfiltersController from "./drawerfilters_controller"
application.register("drawerfilters", DrawerfiltersController)

import DrawerreviewController from "./drawerreview_controller"
application.register("drawerreview", DrawerreviewController)

import DrawerrevieweditController from "./drawerreviewedit_controller"
application.register("drawerreviewedit", DrawerrevieweditController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlatpickrmainController from "./flatpickrmain_controller"
application.register("flatpickrmain", FlatpickrmainController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LoadmoreController from "./loadmore_controller"
application.register("loadmore", LoadmoreController)

import MapsController from "./maps_controller"
application.register("maps", MapsController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)

import RentersController from "./renters_controller"
application.register("renters", RentersController)

import ReservationController from "./reservation_controller"
application.register("reservation", ReservationController)

import ResultsController from "./results_controller"
application.register("results", ResultsController)

import ShowmoreController from "./showmore_controller"
application.register("showmore", ShowmoreController)

import TimeagoController from "./timeago_controller"
application.register("timeago", TimeagoController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)
